import { motion } from "framer-motion";
import React from "react";
import { fadeIn } from "../variants";

const Contact = () => {
  return (
    <section className="section" id="contact">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-start">
          {/* Left side - Info */}
          <motion.div
            variants={fadeIn("right", 0.3)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 space-y-8"
          >
            <div>
              <span className="inline-block px-5 py-2 bg-white border border-stone/40 font-mono font-medium text-sm tracking-wider mb-4 shadow-elegant">
                CONTACT
              </span>
              <h2 className="h2">
                Travaillons
                <br />
                <span className="relative inline-block">
                  Ensemble
                  <span className="absolute -bottom-2 left-0 w-full h-3 bg-gradient-to-r from-gold/40 to-terracotta/40 -z-10 blur-sm" />
                </span>
              </h2>
            </div>

            <div className="space-y-6">
              <p className="text-lg">
                Vous avez un projet en tête ? Une question ? N'hésitez pas à me
                contacter. Je serai ravi d'échanger avec vous !
              </p>

              {/* Contact cards */}
              <div className="space-y-4">
                <div className="p-6 bg-white border border-stone/30 shadow-elegant hover:shadow-elegant-lg transition-all">
                  <p className="font-mono text-sm font-medium text-charcoal/60 mb-1">
                    📧 Email
                  </p>
                  <p className="font-primary font-semibold text-lg">
                    rey.antho21@gmail.com
                  </p>
                </div>

                <div className="p-6 bg-white border border-stone/30 shadow-elegant hover:shadow-elegant-lg transition-all">
                  <p className="font-mono text-sm font-medium text-charcoal/60 mb-1">
                    📍 Localisation
                  </p>
                  <p className="font-primary font-semibold text-lg">Paris, France</p>
                </div>

                <div className="p-6 bg-white border border-stone/30 shadow-elegant hover:shadow-elegant-lg transition-all">
                  <p className="font-mono text-sm font-medium text-charcoal/60 mb-1">
                    💼 Disponibilité
                  </p>
                  <p className="font-primary font-semibold text-lg">
                    A définir
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right side - Form */}
          <motion.div
            variants={fadeIn("left", 0.5)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 w-full"
          >
            <form
              action="https://formspree.io/f/mrgnynyw"
              method="POST"
              className="relative p-8 lg:p-10 bg-white border border-stone/30 shadow-elegant-lg"
            >
              {/* Decorative accent */}
              <div className="absolute -top-4 -right-4 w-20 h-20 bg-gradient-to-br from-navy to-navy-dark opacity-30 rounded-full blur-lg" />

              <div className="space-y-6 relative z-10">
                {/* Name field */}
                <div>
                  <label
                    htmlFor="name"
                    className="block font-mono font-medium text-sm mb-2"
                  >
                    Nom *
                  </label>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    required
                    placeholder="Votre nom"
                    className="w-full px-4 py-3 border border-stone/40 focus:outline-none focus:border-gold/50 focus:shadow-elegant transition-all font-secondary bg-pearl"
                  />
                </div>

                {/* Email field */}
                <div>
                  <label
                    htmlFor="email"
                    className="block font-mono font-medium text-sm mb-2"
                  >
                    Email *
                  </label>
                  <input
                    id="email"
                    type="email"
                    name="_replyto"
                    required
                    placeholder="votre@email.com"
                    className="w-full px-4 py-3 border border-stone/40 focus:outline-none focus:border-gold/50 focus:shadow-elegant transition-all font-secondary bg-pearl"
                  />
                </div>

                {/* Message field */}
                <div>
                  <label
                    htmlFor="message"
                    className="block font-mono font-medium text-sm mb-2"
                  >
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows="6"
                    placeholder="Parlez-moi de votre projet..."
                    className="w-full px-4 py-3 border border-stone/40 focus:outline-none focus:border-gold/50 focus:shadow-elegant transition-all resize-none font-secondary bg-pearl"
                  />
                </div>

                {/* Submit button */}
                <button type="submit" className="btn-primary w-full">
                  Envoyer le message 🚀
                </button>
              </div>
            </form>
          </motion.div>
        </div>

        {/* Footer */}
        <motion.div
          variants={fadeIn("up", 0.8)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.3 }}
          className="mt-20 pt-8 border-t border-stone/30 text-center"
        >
          <p className="font-mono font-medium text-sm">
            Fait avec ❤️ et React par Anthony Rey • {new Date().getFullYear()}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
